
export default {
  orsDictionary: {
    'unknown': 'Desconocido',
    'paved': 'Pavimentado',
    'unpaved': 'Sin pavimentar',
    'asphalt': 'Asfalto',
    'concrete': 'Hormigón',
    'cobblestone': 'Pavimento de piedra',
    'metal': 'Metal',
    'wood': 'Madera',
    'compactedGravel': 'Grava compactada',
    'fineGravel': 'Grava fina',
    'gravel': 'Grava',
    'dirt': 'Camino de tierra',
    'ground': 'Tierra',
    'ice': 'Hielo',
    'pavingStones': 'Paralelepípedo',
    'sand': 'Arena',
    'woodchips': 'Astillas de madera',
    'grass': 'Césped',
    'grassPaver': 'Pavimentación con césped',
    'none': 'Niguna',
    'no': 'No',
    'customers': 'Clientes',
    'destination': 'Destino',
    'delivery': 'Entrega',
    'private': 'Privado',
    'permissive': 'Permisivo',
    'stateRoad': 'Carretera del Estado',
    'road': 'Carretera',
    'street': 'Calle',
    'path': 'Camino',
    'track': 'Sendero',
    'cycleway': 'Ciclovia',
    'footway': 'Passarela',
    'steps': 'Escalera',
    'ferry': 'Ferry',
    'construction': 'En construcción',
    'concrete:lanes': 'Listones de hormigón',
    'paving_stones': 'Pavimento de piedra',
    'sett': 'Paralelepípedo',
    'unhewn_cobblestone': 'Pavimento de piedra irregular',
    'compacted': 'Compactado',
    'fine_gravel': 'Grava fina',
    'pebblestone': 'Piedras pequeñas',
    'impassable': 'Impasible',
    'very_horrible': 'Muy horrible',
    'horrible': 'Horrible',
    'very_bad': 'Muy mal',
    'bad': 'Mal',
    'intermediate': 'Intermediario',
    'good': 'Bueno',
    'excellent': 'Excelente',
    'grade1': 'Nota 1',
    'grade2': 'Nota 2',
    'grade3': 'Nota 3',
    'grade4': 'Nota 4',
    'grade5': 'Nota 5',
    'no_tollway': 'Sin peaje',
    'is_tollway': 'Con peaje',
    'no_category': 'Sin categoría',
    'highway': 'Autopista',
    'unpaved_road': 'Sin pavimento',
    'tunnel': 'Túnel',
    'paved_road': 'Asfaltada',
    'ford': 'Paso de río',
    'no_data': 'Sin datos'
  }
}